import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Customer } from '../classes';
import { CustomerService } from '../services/customer.service';

@Pipe({
  name: 'customerNote'
})
export class CustomerNotePipe implements PipeTransform {

  constructor(private _customerService: CustomerService){ }

  transform(value: number): Observable<string> {
    if(typeof value !== 'number') return of('keine Notiz');
    return this._customerService.getCustomerById(value, true).pipe(map((customer: Customer) => {
      return customer.customernote? customer.customernote: `keine Anmerkungen, Kunde (${[customer.customernumber, customer.customername].filter(x => x? true: false).join(' ')})`;
    }));
  }

}
